import './Loaders.scss';

export const LoadingEllipsis = (props: any) => {
    return (
        <div className={`LoadingEllipsis ${props.klass}`}><div></div><div></div><div></div><div></div></div>
    )
}